import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-motion-effects',
  templateUrl: './motion-effects.component.html',
  styleUrls: ['./motion-effects.component.sass']
})
export class MotionEffectsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
